import { render, staticRenderFns } from "./LyoutYw.vue?vue&type=template&id=27a41d9b&"
import script from "./LyoutYw.vue?vue&type=script&lang=js&"
export * from "./LyoutYw.vue?vue&type=script&lang=js&"
import style0 from "./LyoutYw.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports